import { ExternalLink } from "lucide-react";

// Blocco legale comune ai footer pubblici (dati del titolare forniti dal cliente).
export const LEGAL = {
  titolare: "Marco Paparelli",
  sede: "Viale Regina Margherita, 46 – 00198 Roma",
  piva: "05042811009",
};

export function FooterLegal() {
  return (
    <div className="mt-12 pt-6 border-t border-white/10 space-y-3" data-testid="footer-legal">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-xs text-white/50">© 2026 ESG-PMI · integrato con JOBTIMEHR</p>
        <p className="text-xs text-white/50">Software ESG per PMI · VSME · MEF PMI-Banche · Carbon Calculator</p>
      </div>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-xs text-white/50" data-testid="footer-company-data">
          Titolare: {LEGAL.titolare} · {LEGAL.sede} · P.IVA {LEGAL.piva}
        </p>
        <a href="https://www.jobtimehr.it" target="_blank" rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 text-xs font-semibold text-white/75 hover:text-white transition-colors"
          data-testid="footer-jobtimehr-link">
          Scopri JOBTIMEHR <ExternalLink className="w-3 h-3" aria-hidden="true" />
        </a>
      </div>
    </div>
  );
}
